export default __webpack_public_path__ + "static/chidog-project-ba392af190e059c2461ffff819c2e9bc.jpg";